/* eslint-disable react/forbid-prop-types */
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import AutocompleteSelector from 'ui-coopeuch-autocomplete-selector';
import {
  Card,
  CardContent,
  CardTitlePrimary,
  Input,
  InputPhone,
  Tooltip,
} from '@design-system-coopeuch/web';

import iconMensajeInfo from '../../../assets/img/icon/TooltTip.svg';
import { capitalize } from '../../../../utils/index';
import { DatosPersonales } from './styles';
import { properties } from '../../../../utils/properties';
import Checkbox from '../CheckBox/Checkbox';

const DatosPersonalesCard = ({
  paisSeleccionadoCard,
  regionSeleccionadaCard,
  comunaSeleccionadaCard,
  nombreUsuarioCard,
  dataFormulario,
  listaPaisesCard,
  listaRegionesCard,
  listaComunasCard,
  emailCard,
  pais,
  celular,
  capturarValoresFormularioFuncion,
  autorizoFunction,
  setAutorizo,
}) => {
  const {
    paiseSeleccionado,
    regionSeleccionada,
    comunaSeleccionada,
    formularioDatosPersonales,
    textoAsistidoEmail,
  } = dataFormulario;

  const { email, numeroDeCelular, region } = formularioDatosPersonales[0];

  useEffect(() => {
    capturarValoresFormularioFuncion(nombreUsuarioCard, 'nombreUsuario');
    capturarValoresFormularioFuncion(emailCard, 'email');
    capturarValoresFormularioFuncion(pais, 'pais');
    capturarValoresFormularioFuncion(celular === '0' ? '' : celular, 'telefono');
  }, []);

  return (
    <DatosPersonales>
      <Card>
        <CardTitlePrimary title="Datos Personales" className="" />
        <CardContent>
          <form className="formulario-datos-personales">
            <div className="label-text">
              <h6>Nombre completo</h6>
              <div className="nombre-bloqueado">
                <Input
                  id="nombre-usuario"
                  name="nombre-usuario"
                  value={capitalize(nombreUsuarioCard)}
                  maxLength=""
                  variant="text"
                  disabled
                />
              </div>
            </div>
            <div className="label">
              {pais !== 'CL' && (
                <AutocompleteSelector
                  idElement="pais-selector"
                  label="País de origen"
                  value={paiseSeleccionado}
                  placeholder="Selecciona"
                  name_attr_value="codigo"
                  name_text_node="descripcion"
                  items={listaPaisesCard}
                  onSelection={(e) => paisSeleccionadoCard(e)}
                />
              )}
            </div>
            <div className="label">
              <AutocompleteSelector
                idElement="region-selector"
                label="¿En que región de Chile vives?"
                value={regionSeleccionada}
                placeholder="Selecciona"
                name_attr_value="codigo"
                name_text_node="descripcion"
                items={listaRegionesCard}
                onSelection={(e) => regionSeleccionadaCard(e)}
              />
            </div>
            <div className="label">
              <AutocompleteSelector
                disabled={region === ''}
                idElement="region-selector"
                label="Tu comuna de residencia"
                value={comunaSeleccionada}
                placeholder="Selecciona"
                name_attr_value="codigo"
                name_text_node="descripcion"
                items={listaComunasCard}
                onSelection={(e) => comunaSeleccionadaCard(e)}

              />
            </div>
            <div className="label-fullWidth">
              <Checkbox
                checkboxValue={setAutorizo}
                checkboxName={properties.pasos.paso2.sucursales.chechbox}
                checkboxId="sucursalesCheckbox"
                checkboxStatus={setAutorizo}
                onChange={(e) => autorizoFunction(e.target.value)}
              />
            </div>
            <div className="label">
              <Input
                assistText={textoAsistidoEmail}
                label="Tu Email"
                placeholder={email === '' || email === null ? 'Ej: socio@mail.cl' : emailCard}
                variant="text"
                value={email === '' || email === null ? '' : email}
                onChange={(e) => capturarValoresFormularioFuncion(e, 'email')}
              />
            </div>
            <div className="label">
              <div className="tooltip">
                <p>Tu número de celular</p>
                <Tooltip
                  placement="top-end"
                  eventListener="hover"
                  interactive={false}
                  content="El número de celular debe cumplir el estandar chileno (Ej:+56 9XX XXX XXX)"
                >
                  <img src={iconMensajeInfo} alt="usuario TC" />
                </Tooltip>
              </div>
              <InputPhone
                code={56}
                placeholder="Ej:912345678"
                value={numeroDeCelular === '' ? '' : numeroDeCelular}
                maxLength={9}
                onChange={(e) => capturarValoresFormularioFuncion(e, 'telefono')}
              />
            </div>
          </form>
        </CardContent>
      </Card>
    </DatosPersonales>
  );
};

DatosPersonalesCard.propTypes = {
  paisSeleccionadoCard: PropTypes.func,
  regionSeleccionadaCard: PropTypes.func,
  comunaSeleccionadaCard: PropTypes.func,
  nombreUsuarioCard: PropTypes.string,
  emailCard: PropTypes.string,
  pais: PropTypes.string,
  celular: PropTypes.string,
  dataFormulario: PropTypes.objectOf(PropTypes.any),
  listaPaisesCard: PropTypes.arrayOf(PropTypes.any),
  listaRegionesCard: PropTypes.arrayOf(PropTypes.any),
  listaComunasCard: PropTypes.arrayOf(PropTypes.any),
  capturarValoresFormularioFuncion: PropTypes.func,
  autorizoFunction: PropTypes.func,
  setAutorizo: PropTypes.bool,
};
DatosPersonalesCard.defaultProps = {
  paisSeleccionadoCard: () => { },
  regionSeleccionadaCard: () => { },
  comunaSeleccionadaCard: () => { },
  nombreUsuarioCard: '',
  emailCard: '',
  dataFormulario: '',
  pais: '',
  celular: '',
  listaPaisesCard: '',
  listaRegionesCard: '',
  listaComunasCard: '',
  capturarValoresFormularioFuncion: () => { },
  autorizoFunction: () => { },
  setAutorizo: '',
};

export default DatosPersonalesCard;
